export default "__VITE_ASSET__BRuaXcgS__"